import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

/**
 * Progress Indicator component - exactly as in Clear 1.0
 */
@Component({
  selector: 'cmg-clear2-ui-busy-indicator',
  templateUrl: './cmg-busy-indicator.component.html',
  styleUrls: ['./cmg-busy-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class CmgBusyIndicatorComponent {
  readonly fullScreen = input(true);
  readonly loadingMessage = input<string>();
  zIndex = input<number>(1020);

  @HostBinding('style.z-index')
  get hostZIndex(): number {
    return this.zIndex();
  }
}
